import { render, staticRenderFns } from "./Items.create.vue?vue&type=template&id=29295469&"
import script from "./Items.create.vue?vue&type=script&lang=js&"
export * from "./Items.create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports